import React from 'react'
import styles from '../Components/LanguagesSpokenEachWrapper.module.css'

const LanguagesSpokenEachWrapper = (props) => {
    const { item } = props
    return (
        <div className={styles.mainWrapper}>
            <div className={styles.leftCol}>
                <div className={styles.iconBox}>
                    <img src={item?.language_icon} alt="language icon"  />
                </div>
            </div>
            <div className={styles.rightCol}>
                <div className={styles.colTitle}>
                    {item?.languageSpoken}
                </div>
                <div className={styles.colSubTitle}>
                    {item?.levelOfUnderstanding}
                </div>
            </div>
        </div>
    )
}

export default LanguagesSpokenEachWrapper